import logger from "@plat-components/utils2/_esm5/logger";
// const { init, openApp } = require("@bilibili/h5-utils");
// import { isMobile } from "@plat-components/utils2/_esm5/detector";

function goToVideo(id: string, pageid = 1, type = "bv") {
  // init(); // 判断 ua 类型
  pageid;
  logger("gotovideo_" + id);
  setTimeout(() => {
    window.open(
      `https://www.bilibili.com/video/${type === "av" ? "av" + id : id}`
    );
  }, 50);
}

export default goToVideo;
